import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponToolboxContentProps = PropsWithChildren & {
  className?: string;
};

/**
 * Renders a content grid or flexbox depending on screensize, is to be used with CouponToolboxButtons, should be a direct child to CouponToolbox.
 * this component has a 3-4-3 grid col on screens over the sm mediaquery.
 *
 * @param root0 the input props
 * @param root0.children the children to pass down.
 * @param root0.className additional className for the content div.
 * @returns toolbox buttons parent
 */
export default function CouponToolboxContent({ children, className }: CouponToolboxContentProps): ReactNode {
  return <div className={cn(`flex w-full gap-2 pt-2 pb-2`, className)}>{children}</div>;
}
